import { makeStyles } from "@material-ui/styles";

const timeoutIndicatorStyles = makeStyles((theme) => ({
	container: {
		marginTop: "-5px"
	},
	dot: {
		width: theme.spacing(1),
		height: theme.spacing(1),
		margin: theme.spacing(0, 0.25)
	},
	enabled: {
		color: theme.palette.gameMode.ternary
	},
	disabled: {
		opacity: 0.5
	},
	extraTimeout: {
		color: "#a35924"
	}
}));

export default timeoutIndicatorStyles;
